import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Novurem Patisserie - Feinste Confiserie in Ettlingen</title>
        <meta name="description" content="Novurem Patisserie - Boutique Konditorei mit feinsten Pralinen, Macarons, Torten und Pralinen in Ettlingen. Handwerkskunst mit Kirschrot, Vanillecreme und Pistazie." />
      </Helmet>

      <div className="terms-conditions">
      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
      <p><strong>Stand: Februar 2024</strong></p>

      <section className="terms-section">
        <h2>§1 Geltungsbereich</h2>
        <p>
          (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge, die zwischen der<br />
          <strong>Novurem Patisserie</strong><br />
          [Straße und Hausnummer]<br />
          76275 Ettlingen<br />
          Deutschland<br />
          (nachfolgend "Verkäufer")<br />
          und dem Kunden (nachfolgend "Käufer") über den Online-Shop des Verkäufers geschlossen werden.
        </p>
        <p>
          (2) Die AGB gelten in ihrer jeweiligen Fassung zum Zeitpunkt der Bestellung. Abweichende Bedingungen des Käufers werden nicht anerkannt, es sei denn, der Verkäufer stimmt ihrer Geltung ausdrücklich schriftlich zu.
        </p>
      </section>

      <section className="terms-section">
        <h2>§2 Vertragspartner, Vertragsschluss</h2>
        <p>
          (1) Der Kaufvertrag kommt zustande mit:<br />
          <strong>Novurem Patisserie</strong><br />
          Inhaber: [Name des Inhabers]<br />
          [Straße und Hausnummer]<br />
          76275 Ettlingen<br />
          Deutschland<br />
          E-Mail: <a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a>
        </p>
        <p>
          (2) Die Darstellung der Produkte im Online-Shop stellt kein rechtlich bindendes Angebot dar, sondern eine Aufforderung zur Bestellung. Durch das Absenden der Bestellung im Online-Shop gibt der Käufer ein verbindliches Angebot zum Abschluss des Kaufvertrags ab.
        </p>
        <p>
          (3) Der Verkäufer bestätigt den Eingang der Bestellung per E-Mail. Die Bestellbestätigung stellt noch keine Annahme des Vertragsangebots dar. Der Vertrag kommt erst durch die Versandbestätigung oder die Lieferung der Ware zustande.
        </p>
        <p>
          (4) Der Käufer ist verpflichtet, seine E-Mail-Adresse und die für die Lieferung erforderlichen Daten korrekt anzugeben. Änderungen sind dem Verkäufer unverzüglich mitzuteilen.
        </p>
      </section>

      <section className="terms-section">
        <h2>§3 Vertragsgegenstand</h2>
        <p>
          (1) Der Verkäufer bietet in seinem Online-Shop handgefertigte Patisserie-Produkte an, insbesondere:
        </p>
        <ul>
          <li>Pralinen (verschiedene Sorten und Zusammenstellungen)</li>
          <li>Macarons (verschiedene Geschmacksrichtungen)</li>
          <li>Torten (nach Bestellung, verschiedene Größen und Sorten)</li>
          <li>Saisonale Spezialitäten</li>
          <li>Geschenkboxen und -sets</li>
          <li>Gutscheine</li>
        </ul>
        <p>
          (2) Alle Produkte werden in Handarbeit hergestellt. Geringfügige Abweichungen in Aussehen, Farbe und Gewicht sind daher möglich und stellen keinen Mangel dar.
        </p>
        <p>
          (3) Produktfotos dienen der Veranschaulichung und können vom tatsächlichen Produkt abweichen.
        </p>
      </section>

      <section className="terms-section">
        <h2>§4 Preise und Zahlungsbedingungen</h2>
        <p>
          (1) Alle Preise verstehen sich in Euro (EUR) inklusive der gesetzlichen Mehrwertsteuer (derzeit 7% für Lebensmittel, 19% für sonstige Produkte).
        </p>
        <p>
          (2) Es gelten die zum Zeitpunkt der Bestellung angegebenen Preise. Preisänderungen bleiben vorbehalten, sofern sie nicht bereits bei Vertragsschluss vereinbart wurden.
        </p>
        <p>
          (3) Die Zahlung erfolgt wahlweise per:
        </p>
        <ul>
          <li>Kreditkarte (Visa, Mastercard, American Express)</li>
          <li>PayPal</li>
          <li>SEPA-Lastschrift</li>
          <li>Apple Pay / Google Pay</li>
          <li>Vorkasse (Überweisung)</li>
        </ul>
        <p>
          (4) Bei Auswahl der Zahlungsart Vorkasse nennen wir Ihnen unsere Bankverbindung in der Bestellbestätigung. Der Rechnungsbetrag ist innerhalb von 7 Tagen nach Bestellbestätigung zu überweisen. Bei nicht rechtzeitigem Zahlungseingang behalten wir uns vor, die Bestellung zu stornieren.
        </p>
        <p>
          (5) Bei Zahlung per SEPA-Lastschrift ermächtigen Sie uns, den Rechnungsbetrag von Ihrem Konto einzuziehen. Ein Vorab-Information über den Einzug (Pre-Notification) wird mindestens 5 Tage vor Fälligkeit an Ihre E-Mail-Adresse gesendet.
        </p>
      </section>

      <section className="terms-section">
        <h2>§5 Lieferung und Versand</h2>
        <p>
          (1) Die Lieferung erfolgt innerhalb Deutschlands sowie in ausgewählte EU-Länder. Die Liefergebiete werden im Online-Shop angegeben.
        </p>
        <p>
          (2) Die Lieferzeit beträgt, sofern nicht anders angegeben, 2-5 Werktage nach Zahlungseingang. Auf etwaige abweichende Lieferzeiten wird bei dem jeweiligen Produkt hingewiesen.
        </p>
        <p>
          (3) Für Torten und individuelle Sonderanfertigungen gelten gesonderte Lieferzeiten, die bei der Bestellung angegeben werden. Diese Produkte werden auf Bestellung gefertigt, daher beträgt die Lieferzeit 3-7 Werktage.
        </p>
        <p>
          (4) Der Versand erfolgt mit ausgewählten Versanddienstleistern (z.B. DHL, Hermes, DPD). Die Versandkosten werden dem Käufer vor Abschluss der Bestellung angezeigt.
        </p>
        <p>
          (5) Wir weisen darauf hin, dass unsere Produkte frisch zubereitet und verderblich sind. Sie sind für den Verzehr innerhalb von 3-5 Tagen nach Erhalt bestimmt. Bei bestimmten Produkten (z.B. Torten) kann die Haltbarkeit kürzer sein. Die Haltbarkeit wird auf dem Produkt bzw. in der Produktbeschreibung angegeben.
        </p>
        <p>
          (6) Bei verderblichen Lebensmitteln kann keine Haftung für Transportschäden übernommen werden, die auf eine unsachgemäße Behandlung durch den Versanddienstleister zurückzuführen sind. Der Käufer wird gebeten, die Ware bei Anlieferung zu prüfen und Transportschäden unverzüglich zu melden.
        </p>
      </section>

      <section className="terms-section">
        <h2>§6 Eigentumsvorbehalt</h2>
        <p>
          Bis zur vollständigen Bezahlung bleibt die gelieferte Ware Eigentum des Verkäufers.
        </p>
      </section>

      <section className="terms-section">
        <h2>§7 Widerrufsrecht</h2>
        <p>
          (1) Verbraucher haben das gesetzliche Widerrufsrecht gemäß § 355 BGB.
        </p>
        <p>
          (2) Das Widerrufsrecht erlischt bei Verträgen zur Lieferung versiegelter Waren, die aus Gründen des Gesundheitsschutzes oder aus Hygienegründen nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde (§ 312g Abs. 2 Nr. 2 BGB).
        </p>
        <p>
          (3) Das Widerrufsrecht erlischt ebenfalls bei Verträgen zur Lieferung von Waren, die schnell verderben können oder deren Verfallsdatum schnell überschritten würde (§ 312g Abs. 2 Nr. 2 BGB).
        </p>
        <p>
          (4) Da es sich bei unseren Produkten um frische, schnell verderbliche Lebensmittel handelt, ist ein Widerruf nach Lieferung ausgeschlossen.
        </p>
        <p>
          (5) Für nicht verderbliche Produkte (z.B. Gutscheine, Geschenkboxen ohne Lebensmittel) gilt das gesetzliche Widerrufsrecht von 14 Tagen.
        </p>
      </section>

      <section className="terms-section">
        <h2>§8 Gewährleistung und Haftung</h2>
        <p>
          (1) Es gelten die gesetzlichen Gewährleistungsrechte. Die Gewährleistungsfrist beträgt 24 Monate für nicht verderbliche Produkte.
        </p>
        <p>
          (2) Für frische Lebensmittel gelten besondere Vorschriften. Mängel, die auf die natürliche Beschaffenheit von Lebensmitteln zurückzuführen sind, stellen keinen Sachmangel dar, sofern sie nicht von der vereinbarten Beschaffenheit abweichen.
        </p>
        <p>
          (3) Bei Transportschäden, die auf unsachgemäße Behandlung zurückzuführen sind, ist der Käufer verpflichtet, den Schaden unverzüglich (innerhalb von 48 Stunden nach Erhalt) zu melden, damit wir eine Reklamation beim Versanddienstleister einreichen können.
        </p>
        <p>
          (4) Die Haftung des Verkäufers richtet sich nach den gesetzlichen Bestimmungen. Der Verkäufer haftet unbeschränkt für Vorsatz, grobe Fahrlässigkeit sowie für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
        </p>
        <p>
          (5) Für einfache Fahrlässigkeit haftet der Verkäufer nur, soweit wesentliche Vertragspflichten (Kardinalpflichten) verletzt werden, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Vertragspartner regelmäßig vertrauen darf. Die Haftung ist in diesem Fall auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
        </p>
        <p>
          (6) Die Haftung für Datenverlust wird auf den Aufwand der Wiederherstellung begrenzt, sofern der Datenverlust nicht auf vorsätzlichem oder grob fahrlässigem Verhalten beruht.
        </p>
        <p>
          (7) Die vorstehenden Haftungsbeschränkungen gelten nicht bei arglistigem Verschweigen eines Mangels, bei Übernahme einer Garantie für die Beschaffenheit der Ware sowie bei Ansprüchen nach dem Produkthaftungsgesetz.
        </p>
      </section>

      <section className="terms-section">
        <h2>§9 Sonderanfertigungen</h2>
        <p>
          (1) Individuell angefertigte Torten und Sonderanfertigungen werden nach den Wünschen des Käufers hergestellt. Diese sind vom Widerrufsrecht ausgeschlossen.
        </p>
        <p>
          (2) Bei Sonderanfertigungen können zusätzliche Kosten anfallen, die vor Auftragsbestätigung mitgeteilt werden.
        </p>
        <p>
          (3) Der Käufer ist für die Gestaltungsvorlagen (z.B. Bilder, Farbschemata) verantwortlich. Der Verkäufer haftet nicht für Urheberrechtsverletzungen durch vom Käufer gelieferte Vorlagen.
        </p>
      </section>

      <section className="terms-section">
        <h2>§10 Gutscheine</h2>
        <p>
          (1) Gutscheine können im Online-Shop erworben werden und sind ab Kaufdatum 3 Jahre gültig.
        </p>
        <p>
          (2) Gutscheine können nicht in bar ausgezahlt werden.
        </p>
        <p>
          (3) Ein Gutschein kann nur einmal eingelöst werden. Restbeträge verfallen.
        </p>
      </section>

      <section className="terms-section">
        <h2>§11 Anwendbares Recht und Gerichtsstand</h2>
        <p>
          (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Für Verbraucher gilt diese Rechtswahl nur, soweit nicht der Schutz zwingender Bestimmungen des Staates, in dem der Verbraucher seinen gewöhnlichen Aufenthalt hat, entzogen wird.
        </p>
        <p>
          (2) Sind Sie Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag der Sitz des Verkäufers in Ettlingen.
        </p>
        <p>
          (3) Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie hier finden: <a href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</a>. Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="terms-section">
        <h2>§12 Schlussbestimmungen</h2>
        <p>
          (1) Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
        </p>
        <p>
          (2) Änderungen und Ergänzungen dieser AGB bedürfen der Textform.
        </p>
        <p>
          (3) Vertragssprache ist Deutsch.
        </p>
      </section>
    </div>
  
    </>);
};

export default TermsConditions;